// extracted by mini-css-extract-plugin
export default {"rememberBlock":"remember-forgot_rememberBlock__N1P9X","forgot":"remember-forgot_forgot__IeZGw"};